import { HeureTravaillee } from './heureTravaillee.model';
import { RapportPsychometrique } from './rapportPsychometrique.model';
import { User } from './user.model';

export class DossierIntervention {
    id: number;
    no_dossier: string;
    compagnie_assurance: string;
    nom_assure: string;
    date_perte: string;
    adresse_propriete_endommagee: string;
    personne_contact: string;
    commentaires: string;
    date_rendez_vous: string;
    users: User[];
    activer: boolean;
    heures_travaillees: HeureTravaillee[];
    rapport_psychometrique: RapportPsychometrique;
    expert_name: string;
    phone1: string;
    phone2: string;
    email: string;
    mandat: string;

    public constructor(init?: Partial<DossierIntervention>) {
      Object.assign(this, init);
    }
  }
